import { render, staticRenderFns } from "./PhoneInputNew.vue?vue&type=template&id=843663d4&scoped=true"
import script from "./PhoneInputNew.vue?vue&type=script&lang=js"
export * from "./PhoneInputNew.vue?vue&type=script&lang=js"
import style0 from "./PhoneInputNew.vue?vue&type=style&index=0&id=843663d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843663d4",
  null
  
)

export default component.exports